import {Instagram} from '@/images/icons/instagram'
import {Linkedin} from '@/images/icons/linkedin'
import {Youtube} from '@/images/icons/youtube'

export const socialHandles = {
    facebook: 'pleo.io',
    linkedin: 'pleo-company',
    instagram: 'pleo.io',
    youtube: 'UCQQitvQIlEgIxNyLlOgilXQ',
}

export const socialLinks = [
    {
        handle: socialHandles.linkedin,
        url: `https://www.linkedin.com/company/${socialHandles.linkedin}`,
        icon: Linkedin,
        name: 'LinkedIn',
    },
    {
        handle: socialHandles.instagram,
        url: `https://www.instagram.com/${socialHandles.instagram}`,
        icon: Instagram,
        name: 'Instagram',
    },
    {
        handle: socialHandles.youtube,
        url: `https://www.youtube.com/channel/${socialHandles.youtube}`,
        icon: Youtube,
        name: 'YouTube',
    },
]
